import usuarioVerificadoImg from "assets/logos_finanway/general/usuario_verificado.svg"
import React from "react"
import { Trans, useTranslation } from "react-i18next"
import { TIPO_DOC_LABEL } from "../constants/tipo-doc-label"
import { ReglaCardProps } from "./ReglaCard"
import { TipoPanel } from "./TipoPanel"
import { TypeNav } from "./TypeNav"

const groupByTipoDocumento = (items: ReglaCardProps[]) =>
  items.reduce<Record<number, ReglaCardProps[]>>((acc, it) => {
    if (typeof it.tipoDocumento !== "number") return acc
    if (!acc[it.tipoDocumento]) acc[it.tipoDocumento] = []
    acc[it.tipoDocumento].push(it)
    return acc
  }, {})

export const PageInner: React.FC<{
  data: ReglaCardProps[]
}> = ({ data }) => {
  const { t } = useTranslation()
  const groups = React.useMemo(() => groupByTipoDocumento(data), [data])
  const firstTipo = React.useMemo(
    () => (Object.keys(groups)[0] ? Number(Object.keys(groups)[0]) : null),
    [groups]
  )
  const [activeTipo, setActiveTipo] = React.useState<number | null>(firstTipo)

  React.useEffect(() => {
    if (firstTipo !== null && activeTipo === null) setActiveTipo(firstTipo)
  }, [firstTipo, activeTipo])

  if (!data || Object.keys(groups).length === 0)
    return (
      <div className='tw-p-6 tw-bg-white tw-rounded-md tw-max-w-80 tw-mx-auto tw-shadow-card'>
        <img
          className='tw-mx-auto tw-pb-4'
          src={usuarioVerificadoImg}
          alt='flujo-icon'
        />
        <h3 className='tw-font-medium'>{t("flujoAprobaciones.empty.title")}</h3>
        <div>
          <Trans
            i18nKey='flujoAprobaciones.empty.description'
            components={[
              <p
                className='tw-text-sm'
                key='0'
              />,
              <p
                className='tw-text-sm'
                key='1'
              />,
            ]}
          />
        </div>
      </div>
    )

  return (
    <div className='tw-max-w-screen-lg tw-mx-auto tw-text-left'>
      <main className='tw-px-4 tw-flex tw-gap-6'>
        <aside className='tw-pt-11'>
          <TypeNav
            groups={groups}
            active={activeTipo}
            onSelect={setActiveTipo}
          />
        </aside>
        <section
          key={activeTipo}
          className='tw-space-y-4 tw-animate-fadeIn tw-duration-300 tw-transition-opacity tw-opacity-0 tw-h-[calc(100vh-210px)] tw-overflow-auto'
        >
          {activeTipo !== null && (
            <div>
              <h2 className='tw-text-xl tw-font-medium'>
                {TIPO_DOC_LABEL(t)[activeTipo] ?? `Tipo ${activeTipo}`}
              </h2>
            </div>
          )}
          {activeTipo !== null && (
            <TipoPanel
              tipo={activeTipo}
              reglas={groups[activeTipo] ?? []}
            />
          )}
        </section>
      </main>
    </div>
  )
}
